import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/account");
    else setError(res.error);
  };

  return (
    <div data-testid="register-page" className="grid min-h-[calc(100vh-73px)] lg:grid-cols-2">
      <div className="flex items-center justify-center px-5 py-16 md:px-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="font-serif text-2xl font-medium tracking-tighter text-obsidian">
            LUX<span className="text-signal">•</span>DROP
          </Link>
          <h1 className="mt-8 font-serif text-4xl font-light tracking-tighter text-obsidian">Create account</h1>
          <p className="mt-2 text-sm text-obsidian/60">Save your downloads and track every order.</p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian/60">Name</label>
              <input
                data-testid="register-name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-2 w-full border border-obsidian/20 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1"
                placeholder="Jane Maker"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian/60">Email</label>
              <input
                data-testid="register-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border border-obsidian/20 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1"
                placeholder="you@email.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian/60">Password</label>
              <input
                data-testid="register-password"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border border-obsidian/20 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1"
                placeholder="At least 6 characters"
              />
            </div>

            {error && <p data-testid="register-error" className="text-sm text-signal">{error}</p>}

            <button
              data-testid="register-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-signal py-3.5 text-sm font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-red-700 disabled:opacity-60"
            >
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>

          <p className="mt-6 text-sm text-obsidian/60">
            Already have an account?{" "}
            <Link to="/login" data-testid="to-login-link" className="font-semibold text-signal hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </div>
      <div className="hidden bg-obsidian lg:block">
        <img
          src="https://images.unsplash.com/photo-1622737133809-d95047b9e673"
          alt="Abstract"
          className="h-full w-full object-cover opacity-90"
        />
      </div>
    </div>
  );
}
